export const NEWS_CATEGORIES = [
  { value: 'akimat', label: 'Акимат', color: '#0369A1' },
  { value: 'zhkh', label: 'ЖКХ', color: '#D97706' },
  { value: 'emergency', label: 'ЧС', color: '#DC2626' },
  { value: 'sport', label: 'Спорт', color: '#16A34A' },
  { value: 'transport', label: 'Транспорт', color: '#7C3AED' },
  { value: 'other', label: 'Другое', color: '#64748B' },
];

export const getCategoryColor = (cat?: string) =>
  NEWS_CATEGORIES.find((c) => c.value === cat)?.color || '#64748B';

export const getCategoryLabel = (cat?: string) =>
  NEWS_CATEGORIES.find((c) => c.value === cat)?.label || cat || '—';

/**
 * Canonical districts list — must match the `districts` table in the
 * production DB (post 2026-04-23 parse) and the Flutter app's
 * `profile_setup_screen.dart#_districts`.
 *
 * Push targeting, news targeting and shutoff targeting all key off these
 * exact string values. DO NOT add «Бестау/Чапаево/Пригород» — these are
 * not in the user-profile dropdown so messages targeting them never
 * reach anyone. Add new districts via admin → Геоданные → Районы first,
 * then mirror here + in profile_setup_screen.dart.
 */
export const DISTRICTS = [
  'Аксай — частный сектор',
  'Аксай — мкр.1',
  'Аксай — мкр.2',
  'Аксай — мкр.3',
  'Аксай — мкр.4',
  'Аксай — мкр.5',
  'Аксай — мкр.10',
];

/** Outlying villages of Burlin district — used in `village_screen` only,
 * NOT for push/news targeting (residents register a city district). */
export const BURLIN_VILLAGES = [
  'Караоба',
  'Жанакала',
  'Бескала',
  'Чапаев',
  'Бурлин',
];
